import { isValidBase64 } from '../../../shared/validators/isValidBase64.js';
import { getUserInfo } from './getUserInfo.js';
import { redirectEnrollment } from './registerSession.js';

export const INCONSISTENT_ACCESS_CREDENTIALS = 'login.error';

/**
 * IMPORTANTE: Valida y guarda el sessionInfo > cache = false
 *    12/2023: Usamos flag instance para forzar sí / no el cálculo de redirección
 *
 * @param {*} loginForm
 * @returns
 */
export function validateSession({ user, domain, group, samlAccess, certAccess }, redirection) {
  const params = { user, domain, group, redirection: redirection ? location.hostname : null };
  return getUserInfo(['userId', 'alias', 'domain', 'aliasDomain', 'instanceUrl'], false, params)
    .then((userInfo) => (checkSession(samlAccess, certAccess, user, userInfo, domain) ? userInfo : null))
    .catch((e) => handleValidateSessionError(e, params));
}

function checkSession(samlAccess, certAccess, user, userInfo, domain) {
  return (samlAccess || certAccess || checkUser(user.toUpperCase(), userInfo)) && checkDomain(domain.toUpperCase(), userInfo);
}

function checkUser(user, userInfo) {
  return user === userInfo.userId.toUpperCase() || user === userInfo.alias?.toUpperCase();
}

function checkDomain(domain, userInfo) {
  return domain === userInfo.domain.toUpperCase() || domain === userInfo.aliasDomain?.toUpperCase();
}

// Casos conocidos y que queremos gestionar: BM
function handleValidateSessionError(error, params) {
  // token required
  if (error.code === 'enrollment' && isValidBase64(error.detail)) {
    redirectEnrollment(params, error.detail);
    throw new Error(error.code);
  }

  return null;
}
